import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ReadMoreText from "./ReadMoreText";
import Counter from "./Counter";

import "swiper/css";
import "swiper/css/pagination";

function Why() {
  const [isSlider, setIsSlider] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsSlider(window.innerWidth <= 1024);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const whyItems = [
    {
      icon: "✔",
      title: "Verified & Validated",
      desc: "Multi-layer verification before every delivery. No junk, no duplicates, no outdated records.",
    },
    {
      icon: "⚡",
      title: "Fast Turnaround",
      desc: "Standard datasets in 24 hours. Custom requirements delivered in record time.",
    },
    {
      icon: "🎯",
      title: "Hyper-Specific Targeting",
      desc: "Filter by geography, industry, company size, revenue and 100+ parameters.",
    },
    {
      icon: "📈",
      title: "Built to Scale With You",
      desc: "Start with a dataset. Scale to a full pipeline as your business grows.",
    },
  ];

  return (
    <section className="why-section">
      <div className="container">

        {/* Header */}
        <div className="why-header">
          <span className="section-label">WHY DATRONIQ</span>
          <h2 className="section-title">Data You Can Actually Trust</h2>
        </div>

        <div className="why-grid">

          {/* LEFT VISUAL */}
          <div className="why-visual">

            <div className="why-card card-1">
              <div className="why-num">
                <Counter target={99.6} suffix="%" />
              </div>
              <p className="why-lbl">Verified accuracy rate</p>
            </div>

            <div className="why-card card-2">
              <div className="why-num">24hr</div>
              <p className="why-lbl">Average delivery</p>
            </div>

            <div className="why-card card-3">
              <div className="why-num">
                <Counter target={50} suffix="+" />
              </div>
              <p className="why-lbl">Data categories</p>
            </div>

          </div>

          {/* RIGHT CONTENT */}
          <div className="why-content">

            {isSlider ? (

              /* 🔥 SLIDER */
              <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={20}
                autoplay={{ delay: 2500 }}
                pagination={{ clickable: true }}
                breakpoints={{
                  0: { slidesPerView: 1 },   // ✅ FIXED
                  768: { slidesPerView: 2 },
                }}
              >
                {whyItems.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div className="why-item slider-card">
                      <div className="icon">{item.icon}</div>
                      <div>
                        <h4>{item.title}</h4>
                        <ReadMoreText text={item.desc} />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

            ) : (

              /* 🖥 DESKTOP NORMAL */
              <>
                {whyItems.map((item, i) => (
                  <div className="why-item" key={i}>
                    <div className="icon">{item.icon}</div>
                    <div>
                      <h4>{item.title}</h4>
					  <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </>

            )}

          </div>

        </div>
      </div>
    </section>
  );
}

export default Why;